async function initLogging() {
  // only load the debugger in dev environments
  if (window.zr.page.model.zrDebuggerEnabled) {
    await import('@static/js/zr/zr.debugger');
  }

  await import('@zr/common/js/jquery-plugins/jquery.log_event');
  import('./log_page_view');
  import('./log_events');
}

initLogging();
